module.exports = __webpack_public_path__ + "static/media/45.06657d22.jpg";